// extracted by mini-css-extract-plugin
export default {"section":"groupTreatmentPlans_section__8wPEN","plan":"groupTreatmentPlans_plan__p-bzI","viewBtn":"groupTreatmentPlans_viewBtn__YNmNB","eyeIcon":"groupTreatmentPlans_eyeIcon__e9fiQ"};